import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { Blogpost } from './blogpost.page';
export const routes: Routes = [
    { path: 'blogpost', component: Blogpost }
]
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        Blogpost
    ]
})
export class BlogpostModule {
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/blogpost/blogpost.module.ts